<template>
  <modal
      id="pages-list-modal"
      size="large"
      v-model="showModal"
      :title="from === 'user' ? generateModalTitle('user') : generateModalTitle('Pages')"
      @submit="submit"
      :loading="loading"
      :btn-label="selectedUrl ? $t('save') : $t('add')"
      :preloader="preloader">

    <form
        v-if="(isMailSettingExist || selectedUrl) && !preloader"
        ref="form"
        method="post"
        enctype="multipart/form-data"
        :data-url='selectedUrl ? selectedUrl : CREATE_PAGE'
        @submit.prevent="submitData"
    >
      <div class="row">
        <div class="col-md-12">
          <app-form-group
              type="text"
              :label="$t('name')"
              v-model="formData.name"
              :error-message="$errorMessage(errors, 'name')"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <app-form-group
              type="text"
              :label="$t('title')"
              v-model="formData.title"
              :error-message="$errorMessage(errors, 'title')"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <app-form-group
              type="text"
              :label="$t('slug')"
              v-model="formData.slug"
              :error-message="$errorMessage(errors, 'slug')"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <app-input
              type="text-editor"
              v-model="formData.content"
              v-if="!loading"
              id="content"
              :placeholder="$textAreaPlaceHolder('content')"
              row="5"
              :error-message="$errorMessage(errors, 'custom_content')"
          />
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-md-12">
          <app-form-group
              :label="$t('status')"
              type="radio"
              :list="[
                {id:'active',value: $t('status_active')},
                {id:'inactive', value:  $t('status_inactive')},
            ]"
              v-model="formData.status"
              :error-message="$errorMessage(errors, 'status')"
          />
        </div>
      </div>

    </form>

    <template v-if="!isMailSettingExist && !selectedUrl" slot="footer">
      <button type="button"
              class="btn btn-secondary"
              data-dismiss="modal">
        {{ $t('close') }}
      </button>
    </template>
  </modal>
</template>

<script>
import FormHelperMixins from "../../../../common/Mixin/Global/FormHelperMixins";
import ModalMixin from "../../../../common/Mixin/Global/ModalMixin";
import {
  CREATE_PAGE,
} from "../../../Config/ApiUrl";
import {
  TENANT_MAIL_CHECK_URL,
} from "../../../../common/Config/apiUrl";
import {axiosGet, axiosPost, urlGenerator} from "../../../../common/Helper/AxiosHelper";
import LogMixin from "../../Mixins/LogMixin";
import {textEditorHints} from "../../../../common/Helper/Support/TextEditorHelper";
import TemplateMixins from "../../../../common/Components/Settings/Common/http/NotificationTemplate/TemplateMixins";
import slugify from "slugify";

export default {
  name: "PageCreateEditModal",
  mixins: [FormHelperMixins, ModalMixin, LogMixin, TemplateMixins],
  props: {
    from: {
      type: String,
      default: 'pages'
    },
    loaderColor: {
      type: String,
      default: 'white-color'
    }
  },
  data() {
    return {
      textEditorHints,
      maps: null,
      isMailSettingExist: true,
      preloader: false,
      loading: false,
      formData: {
        name: "",
        title: "",
        slug: "",
        content: "",
        status: "",
      },
      CREATE_PAGE,
    }
  },
  methods: {
    readURL() {
      this.files = this.formData.image.files;
      if (this.files && this.files[0]) {
        let reader = new FileReader();
        reader.onload = function (e) {
          $('#imageResult').attr('src', e.target.result);
        };
        let image = reader.readAsDataURL(this.files[0]);

        let formData = new FormData;

        formData.append('profile_picture', this.files[0]);
        // formData.append('user_id', this.employeeId);
        console.log(formData, image);

        // axiosPost(`admin/auth/users/profile-picture`, formData).then(response => {
        //   // this.$store.dispatch("getUserInformation");
        //   this.$toastr.s(response.data ? response.data.message : '');
        //   window.location.reload()
        // }).catch(error => {
        //   this.$store.dispatch("getUserInformation");
        //   this.$toastr.e(error.response.data ? error.response.data.errors.profile_picture[0] : '');
        // });

      }
    },
    submit() {
      this.fieldStatus.isSubmit = true;
      this.loading = true;
      this.message = '';
      this.errors = {};

      console.log(this.formData);
      this.submitData(this.formData);
    },
    afterSuccess({data}) {
      this.formData = {};
      $('#pages-list-modal').modal('hide');
      console.log('reload ', this.from)
      this.$emit('input', false);
      this.toastAndReload(data.message, this.from === 'pages' ? 'pages-table' : 'user-table');
      if (this.from === 'user') {
        this.$hub.$emit(`reload-pages-table`)
      }
    },
    afterSuccessFromGetEditData({data}) {
      this.preloader = false;
      //Before customization this was "  this.formData = data;"
      this.formData = {...this.formData, ...data};
    },
    generateModalTitle(subject) {
      return this.$fieldTitle(this.selectedUrl ? 'edit' : 'add', subject, true);
    },
  },
  created() {
  },
  computed: {},
  mounted() {
  },
  watch: {
    'formData.name': {
      handler: function () {
        this.formData.slug = slugify(this.formData.name).toLowerCase();
        console.log(this.formData.slug);
        // this.formData.image = this.formData.image ? urlGenerator(this.formData.image) : urlGenerator('/images/core.png');
      }
    }
  }
}
</script>